module.exports = __webpack_public_path__ + "static/media/wait.e5dabffe.png";